"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = 180; // 180 days discussed with backend
